export type DashboardSubtitleDomain = "what's happening" | "your section";

export type DashboardSubtitleInput = {
  domain: DashboardSubtitleDomain;
  taskCount: number | null;
  eventCount: number | null;
  changeRequestCount?: number | null;
};

function formatTaskCount(count: number): string {
  return count === 1 ? "1 task waiting" : `${count} tasks waiting`;
}

function formatEventCount(count: number): string {
  return count === 1 ? "1 upcoming event on the schedule" : `${count} upcoming events on the schedule`;
}

function formatChangeRequestCount(count: number): string {
  return count === 1 ? "1 pending change request" : `${count} pending change requests`;
}

export function getDashboardSubtitle({
  domain,
  taskCount,
  eventCount,
  changeRequestCount = null
}: DashboardSubtitleInput): string {
  const intro = `Here's ${domain} at a glance`;
  const segments: string[] = [];

  if (taskCount !== null && taskCount > 0) {
    segments.push(formatTaskCount(taskCount));
  }

  if (changeRequestCount !== null && changeRequestCount > 0) {
    segments.push(formatChangeRequestCount(changeRequestCount));
  }

  if (eventCount !== null && eventCount > 0) {
    segments.push(formatEventCount(eventCount));
  }

  if (segments.length === 1) {
    return `${intro} — ${segments[0]}.`;
  }

  if (segments.length === 2) {
    return `${intro} — ${segments[0]} and ${segments[1]}.`;
  }

  if (segments.length === 3) {
    return `${intro} — ${segments[0]}, ${segments[1]}, and ${segments[2]}.`;
  }

  return `${intro} — it's a beautiful day to Serve the Member.`;
}

export function getDashboardSubtitleDomain(isHqStaff: boolean): DashboardSubtitleDomain {
  return isHqStaff ? "what's happening" : "your section";
}
